import {
  PEAKACardActions,
  PEAKACardGetters,
  PEAKACardMutations,
} from './pe-aka-card'
import {
  PEAdditionalIdentifiersCardActions,
  PEAdditionalIdentifiersCardGetters,
  PEAdditionalIdentifiersCardMutations,
} from './pe-additional-identifiers-card'
import {
  PEDemographicsCardActions,
  PEDemographicsCardGetters,
  PEDemographicsCardMutations,
} from './pe-demographics-card'
import {
  PEEmailCardActions,
  PEEmailCardGetters,
  PEEmailCardMutations,
} from './pe-email-card'
import {
  PEIdentifiersCardActions,
  PEIdentifiersCardGetters,
  PEIdentifiersCardMutations,
} from './pe-identifiers-card'
import {
  PEImmigrationStatusCardActions,
  PEImmigrationStatusCardGetters,
  PEImmigrationStatusCardMutations,
} from './pe-immigration-status-card'
import {
  PEMailingAddressCardActions,
  PEMailingAddressCardGetters,
  PEMailingAddressCardMutations,
} from './pe-mailing-address-card'
import {
  PENarrativesCardActions,
  PENarrativesCardGetters,
  PENarrativesCardMutations,
} from './pe-narratives'
import {
  PEPassportCardActions,
  PEPassportCardGetters,
  PEPassportCardMutations,
} from './pe-passport-card'
import {
  PEPersonalDetailsCardActions,
  PEPersonalDetailsCardGetters,
  PEPersonalDetailsCardMutations,
} from './pe-personal-details-card'
import {
  PEPhoneCardActions,
  PEPhoneCardGetters,
  PEPhoneCardMutations,
} from './pe-phone-card'
import {
  PEPhysicalAddressCardActions,
  PEPhysicalAddressCardGetters,
  PEPhysicalAddressCardMutations,
} from './pe-physical-address-card'

export const PersonalDataSectionActions = {
  ...PEAKACardActions,
  ...PEAdditionalIdentifiersCardActions,
  ...PEDemographicsCardActions,
  ...PEEmailCardActions,
  ...PEIdentifiersCardActions,
  ...PEImmigrationStatusCardActions,
  ...PEMailingAddressCardActions,
  ...PENarrativesCardActions,
  ...PEPassportCardActions,
  ...PEPersonalDetailsCardActions,
  ...PEPhoneCardActions,
  ...PEPhysicalAddressCardActions,
}

export const PersonalDataSectionGetters = {
  ...PEAKACardGetters,
  ...PEAdditionalIdentifiersCardGetters,
  ...PEDemographicsCardGetters,
  ...PEEmailCardGetters,
  ...PEIdentifiersCardGetters,
  ...PEImmigrationStatusCardGetters,
  ...PEMailingAddressCardGetters,
  ...PENarrativesCardGetters,
  ...PEPassportCardGetters,
  ...PEPersonalDetailsCardGetters,
  ...PEPhoneCardGetters,
  ...PEPhysicalAddressCardGetters,
}

export const PersonalDataSectionMutations = {
  ...PEAKACardMutations,
  ...PEAdditionalIdentifiersCardMutations,
  ...PEDemographicsCardMutations,
  ...PEEmailCardMutations,
  ...PEIdentifiersCardMutations,
  ...PEImmigrationStatusCardMutations,
  ...PEMailingAddressCardMutations,
  ...PENarrativesCardMutations,
  ...PEPassportCardMutations,
  ...PEPersonalDetailsCardMutations,
  ...PEPhoneCardMutations,
  ...PEPhysicalAddressCardMutations,
}
